export class ReduceTimerCache {
    constructor() {
        /**
         * Cache of reduce timers per resultSchema
         * NOTE: Browsers have their own setTimeout/clearTimeout timer implementations
         */
        this.cache = new Map();
    }
    /**
     * Set timer to kick off reduce workflow for resultSchema, after clearing existing timers
     * @param resultSchema Schema of workflow result
     * @param docId Document id of workflow result
     * @param reduceWork Work to kick off reduce workflow
     */
    setReduceTimer(resultSchema, docId, reduceWork, reduceTimeoutMs = 500, shouldDefer = () => false, maxDeferMs = 5000) {
        if (!this.cache.has(resultSchema)) {
            this.cache.set(resultSchema, new Map());
        }
        const timeoutsByDocId = this.cache.get(resultSchema);
        if (timeoutsByDocId.has(docId)) {
            clearTimeout(timeoutsByDocId.get(docId).timer);
        }
        const timerCallback = () => {
            const entry = timeoutsByDocId.get(docId);
            const elapsedMs = Date.now() - entry.start;
            if (shouldDefer() && elapsedMs < maxDeferMs) {
                entry.timer = setTimeout(entry.timerCallback, Math.min(reduceTimeoutMs, maxDeferMs - elapsedMs));
            }
            else {
                if (timeoutsByDocId.size > 1) {
                    timeoutsByDocId.delete(docId);
                }
                else {
                    this.cache.delete(resultSchema);
                }
                reduceWork();
            }
        };
        timeoutsByDocId.set(docId, {
            start: Date.now(),
            timerCallback,
            timer: setTimeout(timerCallback, reduceTimeoutMs)
        });
    }
    /**
     * Clear all existing timers
     * @param resultSchema If set, only clear timers for the given result schema
     * @param docId If set, only clear timers for the given docId
     */
    clear(resultSchema, docId) {
        this.cache.forEach((timeoutsByDocId, schema) => {
            if (!resultSchema || resultSchema === schema) {
                timeoutsByDocId.forEach((timeout, currDocId) => {
                    if (!docId || docId === currDocId) {
                        clearTimeout(timeout.timer);
                    }
                });
            }
        });
        this.cache.clear();
    }
}
//# sourceMappingURL=reduce-timer-cache.js.map